import { render, staticRenderFns } from "./TWOFA.vue?vue&type=template&id=86d390b0&scoped=true&"
import script from "./TWOFA.vue?vue&type=script&lang=js&"
export * from "./TWOFA.vue?vue&type=script&lang=js&"
import style0 from "./TWOFA.vue?vue&type=style&index=0&id=86d390b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.9.6_fb85a9817f99bdf862e5e3a442a1fb91/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86d390b0",
  null
  
)

export default component.exports